<app-nav-menu></app-nav-menu>


<main class="main">
  <div class="container cms_main fadeInUp animated">
    <div class="inner_body">
      <div class="row_card" style="text-align: center;">
        <div class="cms_card-headings">Zeus Insurance Booking Data </div>
      </div>
      <div class="row_card d-flex" style="justify-content: flex-end;column-gap: 10px">
        <button class="button-87" (click)="RouteToZeus()">
          Add New ZEUS 
          <i class="fa fa-plus" style="margin-left:6px;"></i>
        </button>
        <!--<div class="navmenushow1">
    <label class="dropdown ">
      <span class="dd-button button-87">Add New <i class="fa fa-angle-down" style="margin-left: 6px;"
          aria-hidden="true"></i></span>
      <ul class="dd-menu">
        <li (click)="RouteToZeus()">Zeus Insurance Issuance</li>-->
        <!--<li (click)="RouteToUnited()">United Insurance Issuance</li>-->
        <!--</ul>
    </label>
  </div>-->
        <div class="navmenushow2">
          <label class="dropdown ">
            <span class="dd-button button-87">
              Cancel<i class="fa fa-angle-down" style="margin-left: 6px;"
                       aria-hidden="true"></i>
            </span>
            <ul class="dd-menu">
              <li (click)="routeToCancel()">Zeus Insurance Cancel</li>
            </ul>
          </label>
        </div>
      </div>
      <div class="row cms_tabel">
        <div class="col-sm-12">
          <dx-data-grid [dataSource]="zeusPolicies" [showBorders]="true" [showRowLines]="true">
            <dxo-selection mode="single"></dxo-selection>
            <dxo-paging [pageSize]="100"></dxo-paging>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-scrolling mode="standard"></dxo-scrolling>
            <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[50, 100]"></dxo-pager>

            <!-- Flattened purchaseInformation fields -->
            <dxi-column dataField="itineraryID" caption="Itinerary ID" alignment="center"></dxi-column>
            <dxi-column dataField="pnr" caption="PNR" alignment="center"></dxi-column>
            <dxi-column dataField="policyNo" caption="Policy No" alignment="center"></dxi-column>
            <dxi-column dataField="planTitle" caption="Plan Title" alignment="center"></dxi-column>
            <dxi-column dataField="policyPurchasedFlyDate" caption="Fly Date" alignment="center"></dxi-column>
            <!-- <dxi-column dataField="premiumAmount" caption="Premium Amount" alignment="center"></dxi-column> -->
            <dxi-column dataField="totalPremiumAmount" caption="Total Premium" alignment="center"></dxi-column>
            <!-- <dxi-column dataField="totalRevenuePremium" caption="Total Revenue" alignment="center"></dxi-column> -->
            <dxi-column dataField="insuranceName" caption="Insurance Name" alignment="center"></dxi-column>

            <!-- Add action column if needed -->
            <dxi-column caption="Action" [allowSorting]="false" alignment="center"
              cellTemplate="actionCellTemplate"></dxi-column>

            <dxo-search-panel [visible]="true"></dxo-search-panel>

            <div *dxTemplate="let data of 'actionCellTemplate'">
              <div class="card_buttons">
                <a class="card_button-view" style="font-size:18px;margin-right:5px"
                  (click)="showPassengersPopup(data.data.confirmedPassengers)">
                  <i class="uil uil-eye card_button-icon"></i>
                </a>
              </div>
            </div>
          </dx-data-grid>

          <dx-popup [(visible)]="popupVisible" [width]="900" [showTitle]="true" title="Confirmed Passengers"
                    [dragEnabled]="true" [closeOnOutsideClick]="true">
            <!--<div *ngIf="selectedPassengers.length > 0; else noData">
    <dx-data-grid [dataSource]="selectedPassengers" [showBorders]="true" [columnAutoWidth]="true"
      [rowAlternationEnabled]="true">
      <dxi-column dataField="firstName" caption="First Name"></dxi-column>
      <dxi-column dataField="lastName" caption="Last Name"></dxi-column>
      <dxi-column dataField="dob" caption="Date of Birth"></dxi-column>
      <dxi-column dataField="identityNo" caption="Identity No"></dxi-column>
      <dxi-column dataField="policyNo" caption="Policy No"></dxi-column>
      <dxi-column dataField="policyURLLink" caption="Policy Link" cellTemplate="linkTemplate"></dxi-column>
    </dx-data-grid>

    <ng-template #linkTemplate let-data>
      <a [href]="data.policyURLLink" target="_blank">View Policy</a>
    </ng-template>
  </div>-->
            <div *ngIf="selectedPassengers.length > 0; else noData">
              <dx-data-grid [dataSource]="selectedPassengers"
                            [showBorders]="true"
                            [columnAutoWidth]="true"
                            [rowAlternationEnabled]="true">

                <dxi-column dataField="firstName" caption="Passenger Name"></dxi-column>
                <dxi-column dataField="dob" caption="Date of Birth"></dxi-column>
                <dxi-column dataField="identityNo" caption="Identity No"></dxi-column>
                <dxi-column dataField="policyNo" caption="Policy No"></dxi-column>
                <dxi-column caption="Policy Link" cellTemplate="policyTemplate"></dxi-column>

                <div *dxTemplate="let cellData of 'policyTemplate'">
                  <a [href]="cellData.data.policyURLLink"
                     target="_blank"
                     style="color: #007bff; text-decoration: underline; cursor: pointer;">
                    View Policy
                  </a>
                </div>

              </dx-data-grid>

              <ng-template #noData>
                <div class="text-center">No passengers confirmed.</div>
              </ng-template>
            </div>

            <ng-template #noData>
              <p style="text-align:center; padding: 1rem;">No confirmed passengers available.</p>
            </ng-template>
          </dx-popup>


        </div>
      </div>
    </div>
  </div>
</main>
